<template>
  <ValidationProvider
    v-slot="{ errors }"
    :vid="vid"
    :name="name"
    :rules="rules"
    tag="div"
    ref="provider"
  >
    <AGCLabel :required="required">標籤</AGCLabel>

    <!-- selected tags -->
    <div
      class="mb-3"
      style="
        display: flex;
        align-content: center;
        flex-wrap: wrap;
        gap: 0.25rem;
        min-height: 2rem;
      "
    >
      <template v-if="inputVal && inputVal.length > 0">
        <span
          v-for="(tag, idx) in inputVal"
          :key="tag"
          style="
            padding: 0.25rem 0.35rem 0.25rem 0.75rem;
            font-size: 0.8rem;
            border: 1px solid #c8c8c8;
            border-radius: 5px;
            background: #e8e8e8;
            color: #7e8b97;
          "
          :style="{ cursor: disabled ? 'default' : 'pointer' }"
          @click="removeTag(idx)"
        >
          {{ tag }}&nbsp;<b-icon-x></b-icon-x>
        </span>
      </template>
      <div
        v-else
        style="
          opacity: 0.5;
          user-select: none;
        "
      >
        （沒有標籤）
      </div>
    </div>

    <!-- error message -->
    <input v-model="inputVal" type="hidden"/>
    <div
      v-if="errors"
      style="
        margin: 0.75rem 0;
        font-size: 80%;
        color: #dc3545;
      "
    >
      {{ errors[0] }}
    </div>

    <!-- hint -->
    <div
      v-if="!disabled"
      style="
        margin-bottom: 0.25rem;
        font-size: 0.75rem;
        color: #7e8b97;
        user-select: none;
      "
    >
      （輸入文字後可選取現有標籤，或按 "Enter" 新增標籤）
    </div>

    <div
      style="
        max-width: 20rem;
        position: relative;
        margin-left: 0.5rem;
      "
    >
      <!-- input -->
      <div>
        <b-form-input
          v-model.trim="tagInput"
          placeholder="輸入標籤"
          autocomplete="off"
          :disabled="disabled"
          @focus="isAutocompleteShown = true"
          @keydown="isAutocompleteShown = true"
          @keydown.enter="
            addTag(tagInput);
            tagInput = '';
          "
          @click="isAutocompleteShown = true"
          @blur="isAutocompleteShown = false"
        ></b-form-input>
      </div>

      <!-- clear button -->
      <b-button
        v-show="tagInput"
        variant="outline"
        style="
          position: absolute;
          right: 0;
          transform: translateY(-100%);
        "
        @mouseup="tagInput = ''"
      >
        <b-icon-x></b-icon-x>
      </b-button>

      <!-- autocomplete popup -->
      <b-list-group
        v-if="isAutocompleteShown"
        class="shadow"
        style="
          position: absolute;
          width: 100%;
          max-height: 9.25rem;
          overflow-y: auto;
          z-index: 100;
        "
      >
        <b-list-group-item
          v-for="tag in matchedTagOptions"
          :key="tag"
          button
          style="
            padding: 0.25rem 1.25rem;
            line-height: 2rem;
          "
          @mousedown.prevent
          @mouseup="
            isAutocompleteShown = false;
            addTag(tag);
            tagInput = '';
          "
        >
          {{ tag }}
        </b-list-group-item>
      </b-list-group>
    </div>
  </ValidationProvider>
</template>

<script>
import vModelMixin from '@/mixins/v-model';
import axios from 'axios';
import {
  BButton, BFormInput, BIconX, BListGroup, BListGroupItem,
} from 'bootstrap-vue';
import agcFormElementMixin from '../../mixins/agc-form-element';

export default {
  name: 'SearchBar',
  mixins: [agcFormElementMixin, vModelMixin],
  components: {
    BButton,
    BFormInput,
    BIconX,
    BListGroup,
    BListGroupItem,
  },
  props: {
    placeholder: {
      type: String,
      default: '關鍵字...',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    tagOptions: [],
    tagInput: '',
    isAutocompleteShown: false,
  }),
  computed: {
    matchedTagOptions() {
      return this.tagOptions.filter(
        (tag) => !(this.inputVal?.includes(tag) ?? false)
          && tag.toLowerCase().includes(this.tagInput.toLowerCase()),
      );
    },
  },
  methods: {
    addTag(tag) {
      if (!tag) return;

      this.inputVal = this.inputVal ?? [];
      if (!this.inputVal.includes(tag)) this.inputVal.push(tag);
      if (!this.tagOptions.includes(tag)) this.tagOptions.push(tag);
    },
    removeTag(index) {
      if (this.disabled) return;

      this.inputVal.splice(index, 1);
    },
  },
  mounted() {
    axios
      .get('/agc-admin-api/notification/tag')
      .then(({ data: { payload } }) => payload)
      .then((res) => {
        if (res) {
          this.tagOptions = res.map(({ name }) => name.toString());
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally();
  },
};
</script>
